// get-standard-filter-operation.ts
import { A } from "@adornis/base/env-info.js";
import { handleClientRequest } from "@adornis/baseql/client/requestHandler.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import { MongoEntity } from "@adornis/baseql/entities/mongoEntity.js";
import { baseqlMetaData } from "@adornis/baseql/metadata/metaDataStore.js";
import { handleServerRequest } from "@adornis/baseql/server/requestHandler.js";
import { operationName } from "@adornis/baseql/symbols.js";
var getStandardFilterOperation = (entityClass, fallbackOperation, operationName2) => {
  let operation;
  if (operationName2) {
    const operationNode = baseqlMetaData.subscriptions[operationName2] ?? baseqlMetaData.subscriptions[operationName2 + "_prop"];
    if (operationNode)
      operation = A.isClient ? handleClientRequest("subscription", operationNode).bind(entityClass) : handleServerRequest("subscription", operationNode).bind(entityClass);
  }
  if (!operation) {
    let node = baseqlMetaData.entities.find((n) => n.type() === entityClass);
    let isMongoEntity = false;
    while (node?.parent) {
      if (node.parent.type() === AdornisEntity && node.type() === MongoEntity)
        isMongoEntity = true;
      node = node.parent;
    }
    if (isMongoEntity)
      operation = (skip, limit, filter) => {
        return fallbackOperation(entityClass, skip, limit, filter);
      };
  }
  if (!operation)
    throw new Error("didnt pass operation and entity cant be handled automatically");
  return operation;
};
function getOperationName(operation) {
  if (typeof operation === "function")
    return operation[operationName];
  return operation;
}
export {
  getOperationName,
  getStandardFilterOperation
};
